import React, {useEffect, useMemo} from 'react';
import {Stack, Typography, Pagination as MUIPagination} from '@mui/material';

const Pagination = props=>{
    let {total, pageSize, page, setPageSize, setPage} = props;
    let numPages = useMemo(()=>(Math.floor(total/pageSize))+(total%pageSize ? 1 : 0), [total]);
    console.log({total, pageSize, page, numPages})
    useEffect(()=>{
        if (numPages>0&&page>numPages)
            setPage(0);
    }, [page, numPages]);
    return <Stack direction="row" gap={1} alignItems="center" justifyContent="end">
      {numPages>1&&<MUIPagination
        count={numPages}
        page={page+1}
        onChange={(__, v)=>setPage(v-1)}
      />}
      <Typography>
        סה"כ: {total}
      </Typography>
    </Stack>;
};

export default Pagination;
